import { Component, OnInit } from '@angular/core';
import { UserService } from '../service/user.service';
import { HttpService } from '../service/http.service';
import { LoginService } from '../security/login.service';
import { FaviconService } from '../favicon.service';
import { combineLatest, Observable } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { SimpleBrugesVndBooking } from '../simple-bruges-vnd-booking';

@Component({
  selector: 'app-bookings-deleted',
  templateUrl: './bookings-deleted.component.html',
  styleUrls: ['./bookings-deleted.component.css']
})
export class BookingsDeletedComponent implements OnInit {

  bookings!: Observable<SimpleBrugesVndBooking[]>;
  bookingsView!: SimpleBrugesVndBooking[];
  bookingsRaw: SimpleBrugesVndBooking[] = [];
  filteredBookings!: Observable<SimpleBrugesVndBooking[]>;

  searchOption = "studentFirstName";
  recordNumber = 0;
  first: number = 0;
  searchTerm!: string;

  searchForm!: FormGroup;
  filter!: Observable<string>;

  loading = false;

  constructor(
    private httpService: HttpService,
    private loginService: LoginService,
    private favicon: FaviconService,
    private builder: FormBuilder
  ) {
    this.loginService.activatedNavigationComponent = true;
    this.favicon.sbms();
  }

  ngOnInit() {
    this.bookings = this.httpService.getInactiveBookingsWithVademecumAndPicture();
    this.searchForm = this.builder.group({
      searchTerm: ""
    });
    this.filter = this.searchForm.get("searchTerm")!.valueChanges.pipe(startWith(""));
    this.initFilter();
    this.loading = true;
    this.bookings.subscribe(bookings => {
      this.loading = false;
      this.bookingsRaw = bookings;
      this.bookingsView = bookings.slice(0, 49);
      this.recordNumber = bookings.length;
    });
  }

  initFilter() {
    this.filteredBookings = combineLatest([this.bookings, this.filter]).pipe(
      map(([bookings, filterString]) => {
        return bookings.filter(booking =>
          (booking.firstName.toLowerCase().indexOf(filterString.toLowerCase()) != -1) ||
          (booking.lastName.toLowerCase().indexOf(filterString.toLowerCase()) != -1)
        );
      }
      ));
  }

  updateView(event: any) {
    this.bookingsView = this.bookingsRaw.slice(event.first, event.first + event.rows - 1);
  }
}
